import React, { Component } from 'react';
import Button from 'material-ui/Button';
import { withStyles } from 'material-ui/styles';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import Dialog, {
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from 'material-ui/Dialog';

import * as InspectionActions from '../../inspection/inspection.actions';
import * as ReportsActions from '../../reports/reports.actions';
import { getCurrentUser } from '../../user/user.selectors';

const styles = theme => ({
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 150,
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  hide: {
    display: 'none',
  },
});

class PrintReportDialog extends Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
      submitSuccess: false,
    };
  }

  handleCancel = () => {
    this.props.onRequestClose();
    this.setState({
      submitted: false,
      submitSuccess: false,
    });
  };

  handlePrint = () => {
    const { exportInspections, reports } = this.props;
    exportInspections(reports)
      .then(action => {
        if (action && action.response && action.response.status === 'ok') {
          this.setState({
            submitted: true,
            submitSuccess: true,
          });
        } else {
          this.setState({
            submitted: true,
            submitSuccess: false,
          });
        }
      })
      .catch(error => {
        this.setState({
          submitted: true,
          submitSuccess: false,
        });
      });
  };

  userEmail = () => {
    const { currentUser } = this.props;
    if (currentUser) {
      return '(' + currentUser.email + ')';
    }
    return '';
  };

  renderRequest() {
    const { reports } = this.props;
    const count = reports.length;
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Tahdotko tulostaa {count} raporttia?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Peruuta</Button>
          <Button onClick={this.handlePrint} color="primary">
            Tulosta
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderSuccess() {
    return (
      <div>
        <DialogContent>
          <DialogContentText>
            Raportin luonti on aloitettu. Valmis paketti toimitetaan
            sähköpostiosoitteesi {this.userEmail()} hetken kuluttua.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel} color="primary">
            Ok
          </Button>
        </DialogActions>
      </div>
    );
  }

  renderFailure() {
    return (
      <div>
        <DialogTitle>Tulostus ei onnistu</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Yhden tai useamman raportin tulostaminne ei onnistunut. Tarkista
            verkkoyhteytesi ja yritä myöhemmin uudelleen.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={this.handleCancel}>Takaisin</Button>
        </DialogActions>
      </div>
    );
  }

  render() {
    const { open } = this.props;
    const { submitted, submitSuccess } = this.state;
    if (!open) {
      return null;
    }
    return (
      <Dialog onRequestClose={this.handleCancel} open={open}>
        {!submitted
          ? this.renderRequest()
          : submitSuccess ? this.renderSuccess() : this.renderFailure()}
      </Dialog>
    );
  }
}

const mapStateToProps = state => {
  const currentUser = getCurrentUser(state);

  return {
    currentUser,
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    Object.assign({}, InspectionActions, ReportsActions)
  )(withStyles(styles)(PrintReportDialog))
);



// WEBPACK FOOTER //
// ./src/modules/reports/components/PrintReportsConfirm.js